export default function CrochetStudioAd() {
  return (
    <>
      <div className='tw-border-2 tw-border-stone-100 tw-rounded-lg'>
      
        <div className='tw-flex tw-justify-between'>
          <p className="tw-text-3xl tw-font-black tw-text-stone-500 tw-p-4">Have you tried Crochet Studio?</p>
          <p className='tw-pt-2 tw-pr-4 tw-text-stone-400 tw-text-xs'>Advertisment</p>
        </div>

        <div className='tw-flex tw-flex-wrap tw-p-4'>
          <div className='tw-w-full lg:tw-w-1/2'>
            <p className='tw-mb-2'>It's a brand new Crochet app available for iPhone and Android.</p>
            <p className='tw-mb-2'>Beleive me, this is an absolute game changer. Imagine thousands of yarn pegs in your pocket. Make palettes and use in some amazing tools, with many more features coming soon</p>

            <p className='tw-font-black tw-text-stone-600 tw-text-lg tw-text-center tw-mt-10'>It's free! Download today and try it out.</p>
            <div className='tw-flex tw-flex-col tw-items-center tw-mt-10'>
              <a
                href="https://apps.apple.com/us/app/crochet-studio/id1619485014?itsct=apps_box_badge&amp;itscg=30200"
                style={{ display: 'inline-block', overflow: 'hidden', borderRadius: '13px', width: '250px', height: '83px' }}
              >
                <img
                  alt="Download on the App Store"
                  src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1663632000&h=7dd541c7cee8ebb5468e76da0337bc9b"
                  style={{ borderRadius: '13px', width: '250px', height: '83px'}}
                />
              </a>
              <a
                href='https://play.google.com/store/apps/details?id=com.mycraftlife.crochetstudio&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'
                style={{ display: 'inline-block', overflow: 'hidden', borderRadius: '13px', width: '280px', height: '113px' }}
              >
                <img
                  alt='Get it on Google Play'
                  src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'
                />
              </a>
            </div>
            
            <p></p>
          </div>
          <div className='tw-w-full lg:tw-w-1/2 tw-flex tw-gap-2 tw-overflow-scroll'>
            <img src="https://d1zk13bnszbv23.cloudfront.net/images/hero1.png" className='tw-rounded-lg tw-w-56' alt="" />
            <img src="https://d1zk13bnszbv23.cloudfront.net/images/hero2.png" className='tw-rounded-lg tw-w-56' alt="" />
            <img src="https://d1zk13bnszbv23.cloudfront.net/images/hero3.png" className='tw-rounded-lg tw-w-56' alt="" />
            <img src="https://d1zk13bnszbv23.cloudfront.net/images/hero4.png" className='tw-rounded-lg tw-w-56' alt="" />
            <img src="https://d1zk13bnszbv23.cloudfront.net/images/hero5.png" className='tw-rounded-lg tw-w-56' alt="" />
          </div>
        </div>
      
      </div>
    </>
  );
}